import { render, staticRenderFns } from "./YKStudents.vue?vue&type=template&id=3ff6e808&"
import script from "./YKStudents.vue?vue&type=script&lang=js&"
export * from "./YKStudents.vue?vue&type=script&lang=js&"
import style0 from "./YKStudents.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports